var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2958_25615",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 13,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5013 1.16699C4.2813 1.16699 1.66797 3.78033 1.66797 7.00033C1.66797 10.2203 4.2813 12.8337 7.5013 12.8337C10.7213 12.8337 13.3346 10.2203 13.3346 7.00033C13.3346 3.78033 10.7213 1.16699 7.5013 1.16699ZM7.5013 9.91699C7.18047 9.91699 6.91797 9.65449 6.91797 9.33366V7.00033C6.91797 6.67949 7.18047 6.41699 7.5013 6.41699C7.82213 6.41699 8.08464 6.67949 8.08464 7.00033V9.33366C8.08464 9.65449 7.82213 9.91699 7.5013 9.91699ZM6.91797 5.25033H8.08464V4.08366H6.91797V5.25033Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2958_25615)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 14,
    height: 14,
    fill: "#19AB4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessInfo);
export default __webpack_public_path__ + "static/media/success-info.ac6a7bcbcd32110f59d86b0b01b7abc2.svg";
export { ForwardRef as ReactComponent };